
import { FormatAllFloatFieldsAsPercentNumber, GetESRIDataViewURL, GetESRIFeatureServerURL } from '@/utils';
import Metric from '../types/metric';
export default [
    {
        metric: "Labor Force",
        category: 'laborForce',
        code: "qtrs-mihe",
        topic: "LaborForce",
        source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Michigan_Labor_Force"),
        esriViewUrl: GetESRIDataViewURL("bcf9dbd237b741c3b1a2058363101cb9"),
    },
    {
        metric: "Labor Force Participation Rate",
        category: 'laborForce',
        code: "bfer-2y45",
        topic: "LaborForceParticipation",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Labor_Force_Participation_Rate"),
        esriViewUrl: GetESRIDataViewURL("c584156359224a4baaf66bbe94d09d7a"),
    },
    {
        metric: "Labor Force Participation Rate by State",
        category: 'laborForce',
        code: "r2du-fu4p",
        topic: "LaborPartByState",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: null,
        dateProp: '',
        esriSource: GetESRIFeatureServerURL("Labor_Force_Participation_Rate_by_State"),
        esriViewUrl: GetESRIDataViewURL("e321cd6f50154c8fbf1f573a3f9d5df5"),
        esriDataTransform: (data: any) => FormatAllFloatFieldsAsPercentNumber(data, "labor_force_participation_rate"),
    },
    {
        metric: "Payroll Jobs",
        category: 'laborForce',
        code: "vyr4-4e6w",
        topic: "PayrollJobs",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs"),
        esriViewUrl: GetESRIDataViewURL("8cf284ab2d0347d5935a071770c92b1f"),
    },
    {
        metric: "Household Employment",
        category: 'laborForce',
        code: "wbcm-qnpw",
        topic: "HouseEmploy",
        source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Household_Employment"),
        esriViewUrl: GetESRIDataViewURL("4aff89e67fad406ab97255271eddcfb5"),
    },
    {
        metric: "Percent of Population Employed",
        category: 'laborForce',
        code: "49zi-x7ny",
        topic: "PercentPopEmp",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Percent_of_Population_Employed"),
        esriViewUrl: GetESRIDataViewURL("3b4c4ce9f71843bc9ad356b4be645cc3"),
    },
    {
        metric: "Online Job Advertisements vs. Unemployed ",
        category: 'laborForce',
        code: "5esi-5inm",
        topic: "OnlineVsUnemploy",
        source: "Michigan Center for Data and Analytics, DTMB/ The Conference Board, Help Wanted Online Data Series",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Online_Job_Advertisements_vs._Unemployed"),
        esriViewUrl: GetESRIDataViewURL("b5db7c3f90eb445da9aa27c794606b64"),
    },
    {
        metric: "Private Sector Gross Job Gains & Losses",
        category: 'laborForce',
        code: "e2jz-aihp",
        topic: "PvtGrossJobGainLoss",
        source: "Business Employment Dynamics (BED), Michigan Center for Data and Analytics, DTMB",
        rate: 'quarter',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Private_Sector_Gross_Job_Gains_and_Losses"),
        esriViewUrl: GetESRIDataViewURL("766a8972120943739c9ab23952da298d"),
    },
    {
        metric: "Covered Employment",
        category: 'laborForce',
        code: "ds45-bmgg",
        topic: "CoveredEmployment",
        source: "Quarterly Census of Employment and Wages (QCEW), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Covered_Employment"),
        esriViewUrl: GetESRIDataViewURL("d74c601f99964de6b8fd32c4ababe73c"),
    },
    {
        metric: "Unemployment Rate",
        category: 'unemployment',
        code: "kamp-ngb9",
        topic: "Unemployment",
        source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Unemployment_Rate"),
        esriViewUrl: GetESRIDataViewURL("dcea4efc59a1483da3710722dfcf3d78"),
    },
    {
        metric: "Unemployment Rate by State",
        category: 'unemployment',
        code: "qj2w-9cqv",
        topic: "UnemployByState",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: null,
        dateProp: '',
        esriSource: GetESRIFeatureServerURL("Unemployment_Rate_by_State"),
        esriViewUrl: GetESRIDataViewURL("05201cd64045410ba4cae17fc4c746a2"),
        esriDataTransform: (data: any) => FormatAllFloatFieldsAsPercentNumber(data, "unemployment_rate"),
    },
    {
        metric: "Unemployment Rate by Education Level",
        category: 'unemployment',
        code: "i3eb-9m3s",
        topic: "UnemployByEdu",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Unemployment_Rate_by_Education_Level"),
        esriViewUrl: GetESRIDataViewURL("c18c157f618a4d3ba64980d24f8d203b"),
    },
    {
        metric: "Youth Unemployment Rate (16 - 24 years old)",
        category: 'unemployment',
        code: "tdrw-5jnz",
        topic: "YouthUnemploy",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Youth_Unemployment_Rate_(16_-_24_years_old)"),
        esriViewUrl: GetESRIDataViewURL("198158ddda1d4afaaa0c9cdcc223e5a9"),
    },
    {
        metric: "Measure of Labor Underutilization",
        category: 'unemployment',
        code: "qvy3-8uz3",
        topic: "LaborUnderUtil",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'quarter',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Measure_of_Labor_Underutilization_(U-6)"),
        esriViewUrl: GetESRIDataViewURL("ea213ac08ac44df0bb45b34faeb87a21"),
    },
    {
        metric: "Part-Time Rates",
        category: 'unemployment',
        code: "wimi-7c6r",
        topic: "PartTimeRate",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Part-Time_Rate"),
        esriViewUrl: GetESRIDataViewURL("04ba6736998e4c83bf75665bcf3f26a2"),
    },
    {
        metric: "Percent of Unemployed Long-Term Unemployed",
        category: 'unemployment',
        code: "tjgt-hsif",
        topic: "LongTermUnemploy",
        source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Percent_of_Unemployed_Long-Term_Unemployed"),
        esriViewUrl: GetESRIDataViewURL("ee2998874bd1483c8afcc5cb6f5b05d4"),
    },
    {
        metric: "Initial Claims For Unemployment Benefits (52 Week Moving Average) ",
        category: 'unemployment',
        code: "vsec-rvkn",
        topic: "InitClaim4Unemploy",
        source: "U.S. Department of Labor, Employment and Training Administration (ETA)",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Initial_Claims_For_Unemployment_Benefits_(52_Week_Moving_Average)"),
        esriViewUrl: GetESRIDataViewURL("22aa8059eb2c429fad00efe4c56fe92a"),
    },
    {
        metric: "Private Sector Payroll Jobs",
        category: 'industryJobs',
        code: "wrfk-exg9",
        topic: "PriSecPayroll",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Private_Sector_Payroll_Jobs"),
        esriViewUrl: GetESRIDataViewURL("a2210ff23c3d4c44826494a0a250ad91"),
    },
    {
        metric: "Government Payroll Jobs ",
        category: 'industryJobs',
        code: "88ap-tatr",
        topic: "GovPayroll",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Government_Payroll_Jobs"),
        esriViewUrl: GetESRIDataViewURL("69e1b0c05df74b2e8d571951ed46b631"),
    },
    {
        metric: "Payroll Jobs: Manufacturing",
        category: 'industryJobs',
        code: "fp3t-3n5d",
        topic: "PayrollManufact",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Manufacturing"),
        esriViewUrl: GetESRIDataViewURL("ed4481d76a07425fba772a3cdf8ad6e0"),
    },
    {
        metric: "Average Hourly Earnings: Manufacturing",
        category: 'industryJobs',
        code: "bc9f-uqbe",
        topic: "AvgHrsEarnManufactur",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Average_Hourly_Earnings__Manufacturing"),
        esriViewUrl: GetESRIDataViewURL("2feff866be6346f396a06322e50146ca"),
    },
    {
        metric: "Average Weekly Hours: Manufacturing",
        category: 'industryJobs',
        code: "vqnz-33cw",
        topic: "AvgWeekHrsManufactur",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Average_Weekly_Hours__Manufacturing"),
        esriViewUrl: GetESRIDataViewURL("f31dd043537c43f7b5c0534b9dc56924"),
    },
    {
        metric: "Payroll Jobs: Trade, Transportation, and Utilities",
        category: 'industryJobs',
        code: "igjn-gxcg",
        topic: "PayrollTrade",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Trade_Transportation_and_Utilities"),
        esriViewUrl: GetESRIDataViewURL("50ffc23f19a1498a94cadb8ebec73efb"),
    },
    {
        metric: "Payroll Jobs: Private Education and Health Services",
        category: 'industryJobs',
        code: "6c7m-7jr2",
        topic: "PayrollPrivateEduHeath",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Private_Education_and_Health_Services"),
        esriViewUrl: GetESRIDataViewURL("2c6dff8ed5fc4a9b9dc85792f0ce7d5d"),
    },
    {
        metric: "Payroll Jobs: Professional & Business Services",
        category: 'industryJobs',
        code: "suj4-2yhz",
        topic: "PayrollProBusiness",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Professional_and_Business_Services"),
        esriViewUrl: GetESRIDataViewURL("061be6bce1db4f34b015e6b8719bf5c8"),
    },

    {
        metric: "Payroll Jobs: Leisure & Hospitality",
        category: 'industryJobs',
        code: "myzu-iwzg",
        topic: "PayrollLeisure",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Leisure_and_Hospitality"),
        esriViewUrl: GetESRIDataViewURL("18554ffcc6204d7898173adf8c7ca585"),
    },
    {
        metric: "Payroll Jobs: Financial Activities",
        category: 'industryJobs',
        code: "vcm5-dhbc",
        topic: "PayrollFA",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Financial_Activities"),
        esriViewUrl: GetESRIDataViewURL("eb8756a51b65407a937741035c4f2339"),
    },
    {
        metric: "Payroll Jobs: Other Services",
        category: 'industryJobs',
        code: "czfi-bwr8",
        topic: "PayrollOther",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Other_Services"),
        esriViewUrl: GetESRIDataViewURL("aea8250f6f604ef29e459b49ab8d6909"),
    },
    {
        metric: "Payroll Jobs: Construction",
        category: 'industryJobs',
        code: "9u4j-e3u2",
        topic: "PayrollCon",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Construction"),
        esriViewUrl: GetESRIDataViewURL("c425c3f473a249cca2734a5e6acf62a5"),
    },
    {
        metric: "Payroll Jobs: Information",
        category: 'industryJobs',
        code: "9jw7-ipev",
        topic: "PayrollInfo",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Information"),
        esriViewUrl: GetESRIDataViewURL("006092e1b6f04b349805c1d8ee97da6d"),
    },
    {
        metric: "Payroll Jobs: Mining & Logging",
        category: 'industryJobs',
        code: "g6ub-eizc",
        topic: "PayrollMineLog",
        source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Payroll_Jobs__Mining_and_Logging"),
        esriViewUrl: GetESRIDataViewURL("8403fb984d404f5c8ffbf34a9eb6a8f3"),
    },
    {
        metric: "U.S. Light Vehicle Sales",
        category: 'economy',
        code: "awi6-k3et",
        topic: "USLightVehicle",
        source: "Bureau of Economic Analysis",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("U.S._Light_Vehicle_Sales"),
        esriViewUrl: GetESRIDataViewURL("46a0c6c552cc4cb5af63787f6f0cc1e0"),
    },
    {
        metric: "U.S. Retail Sales",
        category: 'economy',
        code: "954f-ercy",
        topic: "USRetail",
        source: "Bureau of the Census",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("U.S._Retail_Sales"),
        esriViewUrl: GetESRIDataViewURL("408f41134938432590b48fa383d71822"),
    },
    {
        metric: "Oil Prices",
        category: 'economy',
        code: "dx9e-uvnm",
        topic: "OilPrices",
        source: "St. Louis Federal Reserve Database",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Oil_Prices"),
        esriViewUrl: GetESRIDataViewURL("1bb4060e5dc34118af0dc3f4396eb1f5"),
    },
    {
        metric: "Natural Gas Prices",
        category: 'economy',
        code: "bknw-gxdr",
        topic: "NaturalGas",
        source: "St. Louis Federal Reserve Database",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Natural_Gas_Prices"),
        esriViewUrl: GetESRIDataViewURL("b57854c1f0f94e40a80f64cd94b50771"),
    },
    {
        metric: "U.S. Housing Starts",
        category: 'economy',
        code: "ta3g-b6yy",
        topic: "USHousing",
        source: "Bureau of the Census",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("U.S._Housing_Starts"),
        esriViewUrl: GetESRIDataViewURL("994f49710e4d4742ada8a27e38dfb737"),
    },
    {
        metric: "Michigan Building Permits",
        category: 'economy',
        code: "9a5w-et7j",
        topic: "BuildingPermit",
        source: "Bureau of the Census",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Michigan_Building_Permits"),
        esriViewUrl: GetESRIDataViewURL("194df8195faf4b969ce2630f3f9a751d"),
    },
    {
        metric: "Michigan Vehicle Production",
        category: 'economy',
        code: "7ufw-v8nq",
        topic: "VehicleProd",
        source: "Office of Revenue and Tax Analysis, Automotive News and Company Reports",
        rate: 'month',
        dateProp: 'month',
        esriSource: GetESRIFeatureServerURL("Michigan_Vehicle_Production"),
        esriViewUrl: GetESRIDataViewURL("f07fe4cffc4e4ee98bb0dca7463ef387"),
    },
    {
        metric: "Detroit Home Prices (Case-Shiller Index)",
        category: 'economy',
        code: "nfju-asiv",
        topic: "HomeIndexPrice",
        source: "S&P Dow Jones Indices and Fiserv",
        rate: 'month',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Detroit_Home_Prices_(Case-Shiller_Index)"),
        esriViewUrl: GetESRIDataViewURL("2eb332c668e0490c9d11cfa87026d9a7"),
    },
    {
        metric: "Michigan Per Capita Personal Income",
        category: 'economy',
        code: "7frj-2rv6",
        topic: "PerCapPersonal",
        source: "Bureau of Economic Analysis",
        rate: 'year',
        dateProp: 'year',
        esriSource: GetESRIFeatureServerURL("Michigan_Per_Capita_Personal_Income"),
        esriViewUrl: GetESRIDataViewURL("8874260e2c834a54890af7bfd593adf1"),
    },
    {
        metric: "Michigan Population",
        category: 'population',
        code: "4fpi-4kt2",
        topic: "MichiganPopuation",
        source: "Bureau of the Census",
        rate: 'year',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Michigan_Population"),
        esriViewUrl: GetESRIDataViewURL("f5a3c2e660904fd99da9df0a0ddf90af"),
    },
    {
        metric: "Michigan Real GDP",
        category: 'economy',
        code: "fcuc-ijab",
        topic: "MichiganGDP",
        source: "Bureau of Economic Analysis",
        rate: 'quarter',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Michigan_Real_GDP"),
        esriViewUrl: GetESRIDataViewURL("795f6bce97e045f197323ffec5a94400"),
    },
    {
        metric: "Educational Attainment",
        category: 'population',
        code: "i24a-p6x8",
        topic: "EducationAttain",
        source: "One-Year Estimates, American Community Survey, U.S. Census Bureau",
        rate: 'year',
        dateProp: 'date',
        esriSource: GetESRIFeatureServerURL("Educational_Attainment"),
        esriViewUrl: GetESRIDataViewURL("19e55e69a3c245069e061b488e95adab"),
    }

] as Array<Metric>;
